export default __webpack_public_path__ + "static/media/AmericanTourister.7a89290a.jpg";